module.exports = __webpack_public_path__ + "img/monke.65b1f455.svg";